/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Washing_CareInputs */

const en_attribute_washing_care = /** @type {(inputs: Attribute_Washing_CareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Washing and care`)
};

/**
* | output |
* | --- |
* | "Washing and care" |
*
* @param {Attribute_Washing_CareInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_washing_care = /** @type {((inputs?: Attribute_Washing_CareInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Washing_CareInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_washing_care(inputs)
});